import API_ENDPOINTS from "../config/apiEndpoints";
import { requestWithAuth } from "./apiClient";

export const apiNotificacionesService = {
  getAllByEmpresa: async (empresaId) => {
    return requestWithAuth(API_ENDPOINTS.NOTIFICACIONES.ALL_EMPRESA(empresaId), {
      method: "GET",
    });
  },

  marcarLeida: async (empresaId, notificacionId) => {
    return requestWithAuth(
      API_ENDPOINTS.NOTIFICACIONES.MARCAR_LEIDA(empresaId, notificacionId),
      { method: "PATCH" }
    );
  },

  eliminar: async (empresaId, notificacionId) => {
    return requestWithAuth(
      API_ENDPOINTS.NOTIFICACIONES.DELETE(empresaId, notificacionId),
      { method: "DELETE" }
    );
  },
};

